(function() {
  let isSearchOpen = false;

  const initSearchTracking = () => {
    if (!window.themeCore || !window.themeCore.EventBus) return;

    // Track Search Open
    window.themeCore.EventBus.listen("Toggle:searchTogglePopup:open", () => {
      // prevent duplicate open handling (just in case)
      if (isSearchOpen) return;

      isSearchOpen = true;

      const pixelData = {
        parent_page: window.location.href
      };

      console.log('Search Open Event Fired:', pixelData);

      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish("search_open", pixelData);
      }
    });

    // Track Search Close (fires only if previously opened)
    window.themeCore.EventBus.listen("Toggle:searchTogglePopup:close", () => {
      // 🚫 ignore if already closed / duplicate fire
      if (!isSearchOpen) return;

      isSearchOpen = false;

      console.log('Search Close Event Fired');

      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish("search_close", {});
      }
    });
  };

  // Ensure we wait until the theme core is fully loaded
  if (window.themeCore && window.themeCore.loaded) {
    initSearchTracking();
  } else {
    document.addEventListener("theme:all:loaded", initSearchTracking, { once: true });
  }
})();
